import styled from "styled-components";

export const TabContainer = styled.div`
  width: 100%;

  .tab-wrapper {
    display: flex;
    justify-content: space-between;
    background-color: #fafafa;
    border: 1px solid #e9eaeb;
    border-radius: 8px;
    padding: 0;
    .tabs {
      display: flex;
      gap: 0px;
      background-color: #fafafa;
      border-radius: 8px;

      .btn-filter {
        display: flex;
        align-items: center;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 8px;
        font-family: "Public Sans", sans-serif;
        font-size: 14px;
        padding: 10px 14px;
        width: auto;
        font-weight: 500;
        color: #717680;
        transition: all 0.2s ease;
        height: auto;
        line-height: 1;

        svg {
          fill: ${({ theme }) => theme.input.placeholder.secondary};
          path {
            fill: ${({ theme }) => theme.input.placeholder.secondary};
          }
        }

        &:hover {
          background: rgba(165, 199, 255, 0.05);
          box-shadow: none;
        }

        &.active {
          color: #414651;
          background-color: #ffffff;
          border: 1px solid #d5d7da;
          font-weight: 500;

          .no-filter {
            filter: none;
          }

          svg {
            fill: ${({ theme }) => theme.tab.color.senary};
            path {
              fill: ${({ theme }) => theme.tab.color.senary};
            }
          }
        }

        .custom-g-path {
          g path {
            fill: ${({ theme }) => theme.tab.color.quaternary};
          }
        }

        &:disabled {
          background: transparent !important;
          color: ${({ theme }) => theme.card.font.secondary} !important;
          border: 0px !important;
          opacity: 0.5;

          svg {
            fill: ${({ theme }) => theme.aside.font.color} !important;
          }
          .only-stroke {
            fill: none !important;
            stroke: ${({ theme }) => theme.aside.font.color} !important;
          }
        }

        svg {
          margin-right: 10px;
        }
      }
    }
  }

  .divider {
    margin: 0.8em 0;
  }
`;
